import { PayloadAction, createSelector, createSlice, current } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { OrganisationCountryConfig, PreparationCentre } from './types';

export const B2B_PRODUCT_SUB_SYSTEM_ID = 2;

export interface CountryState {
  selectedCountry?: OrganisationCountryConfig & { id: number };
  panNumberCountries: number[];
  preparationCentre?: PreparationCentre;
}

const initialState: CountryState = {
  selectedCountry: undefined,
  preparationCentre: undefined,
  panNumberCountries: [
    61, //NepalId
  ],
};

export const countrySelectorSlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountry: (state, action: PayloadAction<OrganisationCountryConfig & { id: number }>) => {
      state.selectedCountry = action.payload;
      if (current(state).preparationCentre?.countryId !== action.payload.id) {
        state.preparationCentre = undefined;
      }
    },
    setPreparationCentre: (state, action: PayloadAction<PreparationCentre>) => {
      state.preparationCentre = action.payload;
    },
    clearPreparationCentre: (state) => {
      state.preparationCentre = undefined;
    },
  },
});

export const { setCountry, setPreparationCentre, clearPreparationCentre } = countrySelectorSlice.actions;

export const selectCountryState = (state: RootState) => state.country;

export const selectSelectedCountry = createSelector(selectCountryState, (country) => country.selectedCountry);

export const selectSelectedCountryId = createSelector(selectSelectedCountry, (selectedCountry) =>
  selectedCountry ? `${selectedCountry.id}` : ''
);

export const selectSelectedCountryName = createSelector(
  selectSelectedCountry,
  (selectedCountry) => selectedCountry?.name
);

export const isPanNumberCountry = createSelector(
  selectCountryState,
  (country) => country.selectedCountry && country.panNumberCountries.includes(country.selectedCountry?.id)
);

export const selectPreparationCentre = createSelector(selectCountryState, (country) => country.preparationCentre);

export default countrySelectorSlice.reducer;
